import axios from "axios";

const axiosServices = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://122.0.0.1:8000/api/v1.0/",
  headers: {
    "Content-Type": "application/json",
  },
});

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      // Don't redirect if this is a login/signup request - let the form handle the error
      if (!error.config.url.includes("/login/") && !error.config.url.includes("/frontend_registration/")) {
        window.location = "/";
      }
    }
    return Promise.reject(
      (error.response && error.response.data) || "Wrong Services"
    );
  }
);

export default axiosServices;
